module.exports = __webpack_public_path__ + "static/media/visto.deb1a752.svg";